/* eslint-disable */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './CardProduct.css';

class CardProductDemo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricearray: this.props.shopitem.pricetable,
    };
  }

  getpricearray() {
    if (this.state.pricearray != undefined) {
      var rows = this.state.pricearray.split('##');
      if (rows.length > 0) {
        var items = rows[0].split('**');
        if (items.length >= 6) {
          return items[1];
        }
      }
    }
    return '';
  }

  render() {
    return (
      <div
        className='product-gallery-card'
        onClick={() => this.props.callback_editproduct(this.props.shopitem)}
      >
        <div className='gallery-card-image'>
          <img
            src={
              '/api/product/file/productitem/' +
              this.props.shopitem.productitem_id +
              '/' +
              this.props.shopitem.productitem_id +
              '-1-' +
              this.props.shopitem.img1_key +
              '.jpg'
            }
            alt={this.props.shopitem.productitem_name}
            onError={(e) => {
              e.target.src = '/images/blank.png';
            }}
          />
        </div>

        <div className='gallery-card-content'>
          <div className='gallery-card-id'>{this.props.shopitem.productitem_id}</div>
          <div className='gallery-card-name-th'>{this.props.shopitem.productitem_name}</div>
          <div className='gallery-card-name-en'>{this.props.shopitem.productitem_inter}</div>
          <div className='gallery-card-suffix'>
            {this.props.shopitem.productitem_desc?.substring(0, 20)}
          </div>
        </div>
      </div>
    );
  }
}

CardProductDemo.propTypes = {
  callback_editproduct: PropTypes.func,
};

export default CardProductDemo;
